/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Address_Selectcountryplaceholder2Inputs */

const en_address_selectcountryplaceholder2 = /** @type {(inputs: Address_Selectcountryplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select country`)
};

/**
* | output |
* | --- |
* | "Select country" |
*
* @param {Address_Selectcountryplaceholder2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const address_selectcountryplaceholder2 = /** @type {((inputs?: Address_Selectcountryplaceholder2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Address_Selectcountryplaceholder2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_address_selectcountryplaceholder2(inputs)
});
export { address_selectcountryplaceholder2 as "address_selectCountryPlaceholder" }